module.exports = __webpack_public_path__ + "img/p-one-step-17.51c1da84.png";